import { TSaveClient } from "../../clientUiTypes";
import CompleteClientFlow from "../../client-forms/CompleteClientFlow/CompleteClientFlow";
import { IClient } from "intake_shared/src/types";

interface FollowUpProps {
    client: IClient;
    onSaveClient: TSaveClient;
}

export default function FollowUp({ client, onSaveClient }: FollowUpProps) {
    return (
        <div>
            <CompleteClientFlow
                clientProp={client}
                expectedCaller="admin"
                showAppointmentsToCancel={true}
                showCompletionReason
                showCompletionNotes
                onSaveClient={onSaveClient}
            />
        </div>
    );
}
